<template>
  <div clas="row">
    <div class="col-xs-12 col-md-10 col-md-offset-1">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-sm-push-6">
          <div class="you-may-also-like-header__view-more-link-wrapper">
            <a
              :href="catalogListUrl"
              class="you-may-also-like-header__view-more-link"
            >
              <contentful-text :item="contentfulText('you-may-also-like-top-link-text')"/>
              <span class="fa fa-chevron-right"/>
            </a>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-sm-pull-6">
          <h3 class="you-may-also-like-header__lede">
            <contentful-text :item="contentfulText('you-may-also-like-header-lede')"/>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentfulMixin from '@Shared/mixins/contentful.js'

export default {
  name: 'YouMayAlsoLikeHeader',
  mixins: [ContentfulMixin],
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  computed: {
    catalogListUrl () {
      return this.$store.state.catalogPageCommon.catalogListUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.you-may-also-like-header {
  &__view-more-link {
    color: $grad-color-purple;
    font-weight: bold;
    font-size: 16px;

    &-wrapper {
      text-align: right;
      margin-bottom: 20px;
    }

    &:hover {
      text-decoration: none;
      border-bottom: 2px solid $grad-color-purple;
    }
  }

  &__lede {
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    font-family: $font-open-sans;
    font-weight: bold;
    text-align: center;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__view-more-link {
      &-wrapper {
        margin-bottom: 0;
      }
    }

    &__lede {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/YouMayAlsoLike/Header.vue